class DirecionamentoEnum {
  constructor() {
    this.PUBLICO = 1;
    this.FROTISTA = 2;
    this.GRUPO_FROTISTA = 3;
  }

  getTiposLabel() {
    return [
      { label: 'Público', value: this.PUBLICO },
      { label: 'Frotista', value: this.FROTISTA },
      { label: 'Grupo Frotista', value: this.GRUPO_FROTISTA },
    ];
  }

  getTipo(direcionamento) {
    return this.getTiposLabel()
      .filter(label => label.value === direcionamento)
      .shift();
  }
}

export default new DirecionamentoEnum();
